import { BodyLG, BodyXL, Heading2XL, Heading3XL } from "../../../typography";

interface ProblemItem {
  icon: string;
  text: string;
}

const SECTION_LABEL = "Problem";
const SECTION_HEADING =
  "Fragmented DME networks increase complexity, cost, and care delays.";

const PROBLEM_ITEMS: ProblemItem[] = [
  {
    icon: "/landing_page_assets/payor_network_page/problem-network.png",
    text: "Payors manage hundreds to thousands of DME contracts.",
  },
  {
    icon: "/landing_page_assets/payor_network_page/problem-chart.png",
    text: "Overutilization and outdated fee schedules drive up spend.",
  },
  {
    icon: "/landing_page_assets/payor_network_page/problem-ambulance.png",
    text: "Delayed deliveries lead to grievances and high-cost care.",
  },
];

export const ProblemSection = () => {
  return (
    <div className="tw-flex tw-min-h-[600px] tw-flex-col tw-items-center tw-justify-center tw-gap-y-[4em] tw-px-[1.25em] tw-py-[5em] min440:tw-px-[4.75em] min840:tw-min-h-[800px] min840:tw-py-[7.5em]">
      <div className="tw-flex tw-w-full tw-max-w-[1448px] tw-flex-col tw-gap-y-[4em]">
        <div className="tw-flex tw-flex-col tw-gap-y-[1em]">
          <div className="tw-w-full">
            <BodyXL className="tw-my-0 tw-hidden tw-text-left tw-text-gray-2 min440:tw-flex">
              {SECTION_LABEL}
            </BodyXL>
            <BodyLG className="tw-my-0 tw-text-left tw-text-gray-2 min440:tw-hidden">
              {SECTION_LABEL}
            </BodyLG>
          </div>
          <Heading3XL className="tw-my-0 tw-hidden tw-text-left min440:tw-flex">
            {SECTION_HEADING}
          </Heading3XL>
          <Heading2XL className="tw-my-0 tw-text-left min440:tw-hidden">
            {SECTION_HEADING}
          </Heading2XL>
        </div>

        <div className="tw-flex tw-flex-col tw-gap-x-[2em] tw-gap-y-[2em] min1040:tw-flex-row min1040:tw-justify-center min1040:tw-gap-x-[8em] min1040:tw-gap-y-0">
          {PROBLEM_ITEMS.map((item, index) => (
            <div
              key={index}
              className="tw-flex tw-flex-col tw-items-center tw-gap-y-[1.5em] tw-px-[2em] min1040:tw-max-w-[360px]"
            >
              <div className="tw-flex tw-h-[120px] tw-w-[120px] tw-items-center tw-justify-center tw-rounded-full">
                <img
                  src={item.icon}
                  alt=""
                  className="tw-h-[120px] tw-w-[120px] tw-object-contain"
                />
              </div>
              <BodyXL className="tw-my-0 tw-hidden tw-text-center tw-text-gray-2 min440:tw-flex">
                {item.text}
              </BodyXL>
              <BodyLG className="tw-my-0 tw-text-center tw-text-gray-2 min440:tw-hidden">
                {item.text}
              </BodyLG>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
